const SELECTOR_TEXT_BOX = ".lbh-bewertung-text";
const SELECTOR_BUTTON_MORE = ".lbh-bewertung-mehr";
const SELECTOR_CSS_LINK = '.lbh-main-styles';

const STATE_MORE = "more";
const STATE_LESS = "less";

class BuchhaendlerBewertung extends HTMLElement {
  connectedCallback() {
    if (this.dataset.headOnly === "false") {
      this.setElements();
      this.bindEvents();
      this.calculateInitialTextState()
    }
  }

  setElements() {
    this.textBoxElem = this.querySelector(SELECTOR_TEXT_BOX);
    this.buttonElem = this.querySelector(SELECTOR_BUTTON_MORE);
    this.linkElement = this.querySelector(SELECTOR_CSS_LINK);
  }

  bindEvents() {
    this.buttonElem.addEventListener('click', (event) => this.toggleText(event));
    window.addEventListener('resize', () => this.calculateButtonMoreState());
  }

  calculateInitialTextState() {
    this.textBoxHeight = this.textBoxElem.clientHeight;
    this.calculateButtonMoreState();
  }

  toggleText(event) {
    this.textBoxElem.style.maxHeight = event.target.dataset.state === STATE_MORE ? `${this.textBoxElem.scrollHeight}px` : `${this.textBoxHeight}px`;
    event.target.setAttribute("data-state", event.target.dataset.state === STATE_MORE ? STATE_LESS : STATE_MORE);
    event.target.innerHTML = event.target.dataset.state === STATE_MORE ? "Weiterlesen" : "Weniger";
    this.buttonElem.blur();
  }

  calculateButtonMoreState() {
    this.buttonElem.style.display = (this.textBoxElem.scrollHeight > this.textBoxElem.offsetHeight) ? 'block' : 'none';
  }
}
  
if (!customElements.get("buchhaendler-bewertung")) {
  customElements.define("buchhaendler-bewertung", BuchhaendlerBewertung);
}
  